import { jsxs as s, jsx as e, Fragment as f } from "react/jsx-runtime";
import p, { useState as b, useEffect as h } from "react";
import { Dropdown as $ } from "../../Dropdown/Dropdown.js";
import { Input as t } from "../../Input/Input.js";
import "../../Input/BaseInput.js";
import l from "../../TextArea/TextArea.js";
import { Wrapper as y, AddressContainer as C, InputContainer as o } from "./styled.js";
const A = ({
  fieldName: n,
  mode: r,
  loadCountriesHandler: a,
  fullAddressTextAreaProps: i,
  countryDropDownProps: u
}) => {
  const [c, d] = b([]);
  return h(() => {
    (async () => {
      const m = await a();
      d(m);
    })();
  }, [a]), /* @__PURE__ */ s(y, { children: [
    /* @__PURE__ */ e(
      $,
      {
        name: `${n}.overseas.country`,
        label: "Country",
        options: c,
        placeholder: "Select",
        ...u
      }
    ),
    /* @__PURE__ */ e(C, { $mode: r, children: r === "Basic" ? /* @__PURE__ */ e(
      l,
      {
        name: `${n}.overseas.info.basic`,
        label: "Address",
        hint: "Please enter your international address",
        maxLength: 300,
        ...i
      }
    ) : /* @__PURE__ */ s(f, { children: [
      /* @__PURE__ */ e(o, { children: /* @__PURE__ */ e(
        l,
        {
          name: `${n}.overseas.info.full.fullAddress`,
          mode: "Input",
          label: "Street address",
          hint: "Please include unit number if needed"
        }
      ) }),
      /* @__PURE__ */ e(o, { children: /* @__PURE__ */ e(t, { name: `${n}.overseas.info.full.suburb`, label: "City/Town/Suburb" }) }),
      /* @__PURE__ */ e(o, { children: /* @__PURE__ */ e(
        t,
        {
          name: `${n}.overseas.info.full.state`,
          label: "State/Region/Province (if applicable)"
        }
      ) }),
      /* @__PURE__ */ e(o, { children: /* @__PURE__ */ e(
        t,
        {
          name: `${n}.overseas.info.full.postCode`,
          label: "ZIP/Postcode (if applicable)"
        }
      ) })
    ] }) })
  ] });
}, R = p.memo(A, (n, r) => !(n.fieldName !== r.fieldName || n.mode !== r.mode || n.loadCountriesHandler !== r.loadCountriesHandler));
export {
  R as default
};
